/** Languages supported by the online IDE (Judge0). `problem: true` = also on problem solve page. */
export const COMPILER_LANGUAGES = [
  {
    id: 'python',
    label: 'Python',
    shortLabel: 'Python',
    monaco: 'python',
    judge0: 71,
    problem: true,
    starter:
      'import sys\n\ndef main():\n    data = sys.stdin.read().strip()\n    print("Hello, CrafterHack!")\n    if data:\n        print(data)\n\nif __name__ == "__main__":\n    main()',
  },
  {
    id: 'javascript',
    label: 'JavaScript (Node)',
    shortLabel: 'JS',
    monaco: 'javascript',
    judge0: 63,
    problem: true,
    starter:
      'const fs = require("fs");\n\nconst input = fs.readFileSync(0, "utf8").trim();\nconsole.log("Hello, CrafterHack!");\nif (input) console.log(input);',
  },
  {
    id: 'java',
    label: 'Java',
    shortLabel: 'Java',
    monaco: 'java',
    judge0: 62,
    problem: true,
    starter:
      'import java.util.*;\n\npublic class Main {\n    public static void main(String[] args) {\n        Scanner sc = new Scanner(System.in);\n        System.out.println("Hello, CrafterHack!");\n        if (sc.hasNextLine()) {\n            String line = sc.nextLine();\n            if (!line.isEmpty()) System.out.println(line);\n        }\n    }\n}',
  },
  {
    id: 'cpp',
    label: 'C++',
    shortLabel: 'C++',
    monaco: 'cpp',
    judge0: 54,
    problem: true,
    starter:
      '#include <iostream>\nusing namespace std;\n\nint main() {\n    string line;\n    cout << "Hello, CrafterHack!" << endl;\n    if (getline(cin, line) && !line.empty()) cout << line << endl;\n    return 0;\n}',
  },
  {
    id: 'csharp',
    label: 'C#',
    shortLabel: 'C#',
    monaco: 'csharp',
    judge0: 51,
    problem: true,
    starter:
      'using System;\n\npublic class Program {\n    public static void Main(string[] args) {\n        Console.WriteLine("Hello, CrafterHack!");\n        var line = Console.ReadLine();\n        if (!string.IsNullOrEmpty(line)) Console.WriteLine(line);\n    }\n}',
  },
  {
    id: 'go',
    label: 'Go',
    shortLabel: 'Go',
    monaco: 'go',
    judge0: 60,
    problem: false,
    starter:
      'package main\n\nimport (\n\t"bufio"\n\t"fmt"\n\t"os"\n)\n\nfunc main() {\n\tfmt.Println("Hello, CrafterHack!")\n\tscanner := bufio.NewScanner(os.Stdin)\n\tif scanner.Scan() {\n\t\tline := scanner.Text()\n\t\tif line != "" {\n\t\t\tfmt.Println(line)\n\t\t}\n\t}\n}',
  },
  {
    id: 'rust',
    label: 'Rust',
    shortLabel: 'Rust',
    monaco: 'rust',
    judge0: 73,
    problem: false,
    starter:
      'use std::io::{self, Read};\n\nfn main() {\n    println!("Hello, CrafterHack!");\n    let mut input = String::new();\n    if io::stdin().read_to_string(&mut input).is_ok() {\n        let trimmed = input.trim();\n        if !trimmed.is_empty() {\n            println!("{}", trimmed);\n        }\n    }\n}',
  },
  {
    id: 'typescript',
    label: 'TypeScript',
    shortLabel: 'TS',
    monaco: 'typescript',
    judge0: 74,
    problem: false,
    // Judge0's TS runtime (3.7.4) has no @types/node, so `import ... from "fs"`
    // fails to typecheck (TS2307: Cannot find module 'fs'). Go through the
    // untyped `require` global instead — same fs.readFileSync at runtime,
    // but skips module-resolution typechecking entirely.
    starter:
      'declare const require: any;\nconst fs = require("fs");\n\nconst input = fs.readFileSync(0, "utf8").trim();\nconsole.log("Hello, CrafterHack!");\nif (input) console.log(input);',
  },
  {
    id: 'kotlin',
    label: 'Kotlin',
    shortLabel: 'Kotlin',
    monaco: 'kotlin',
    judge0: 78,
    problem: false,
    starter:
      'fun main() {\n    println("Hello, CrafterHack!")\n    readLine()?.trim()?.takeIf { it.isNotEmpty() }?.let { println(it) }\n}',
  },
  {
    id: 'php',
    label: 'PHP',
    shortLabel: 'PHP',
    monaco: 'php',
    judge0: 68,
    problem: false,
    starter:
      '<?php\n$input = trim(stream_get_contents(STDIN));\necho "Hello, CrafterHack!\\n";\nif ($input !== "") echo $input . "\\n";\n',
  },
  {
    id: 'ruby',
    label: 'Ruby',
    shortLabel: 'Ruby',
    monaco: 'ruby',
    judge0: 72,
    problem: false,
    starter:
      'input = STDIN.read.strip\nputs "Hello, CrafterHack!"\nputs input unless input.empty?',
  },
];

export const languageMapping = Object.fromEntries(
  COMPILER_LANGUAGES.map((lang) => [lang.id, lang.judge0]),
);

export const languageIdMapping = Object.fromEntries(
  COMPILER_LANGUAGES.map((lang) => [lang.judge0, lang.id]),
);

export const defaultCode = Object.fromEntries(
  COMPILER_LANGUAGES.map((lang) => [lang.id, lang.starter]),
);

export const PROBLEM_LANGUAGES = COMPILER_LANGUAGES.filter((lang) => lang.problem);

export const isCompilerLanguage = (id) =>
  COMPILER_LANGUAGES.some((lang) => lang.id === id);

export const getCompilerLanguage = (id) =>
  COMPILER_LANGUAGES.find((lang) => lang.id === id) || COMPILER_LANGUAGES[0];

export const getMonacoLanguage = (id) => {
  const lang = getCompilerLanguage(id);
  if (lang.monaco === 'cpp') return 'cpp';
  return lang.monaco;
};
